// import React from "react";
import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
// import "animate.css";

const NotifyMessage = (titleMsg, typeNotify, reloadtype) => {
  Store.addNotification({
    title: titleMsg,
    type: typeNotify,
    insert: "top",
    container: "bottom-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 1500,
      showIcon: true,
      onScreen: true,
    },
    onRemoval: (reloadtype) => {
      if (reloadtype) {
        window.location.reload();
      }
    },
  });
};

export default NotifyMessage;
